import { render } from "./SolucoesComponent.vue?vue&type=template&id=6273ee0b&scoped=true"
import script from "./SolucoesComponent.vue?vue&type=script&lang=js"
export * from "./SolucoesComponent.vue?vue&type=script&lang=js"

import "./SolucoesComponent.vue?vue&type=style&index=0&id=6273ee0b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6273ee0b"]])

export default __exports__